import { motion } from 'motion/react';
import styles from './SaveQuizButton.module.scss';

interface SaveQuizButtonProps {
  onSave: () => void;
  isValid: boolean;
  isSaving: boolean;
}

export function SaveQuizButton({ onSave, isValid, isSaving }: SaveQuizButtonProps) {
  return (
    <motion.button
      className={`${styles.saveButton} ${!isValid ? styles['saveButton--disabled'] : ''}`}
      onClick={onSave}
      disabled={!isValid || isSaving}
      whileHover={isValid && !isSaving ? { scale: 1.05 } : {}}
      whileTap={isValid && !isSaving ? { scale: 0.95 } : {}}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      {isSaving ? (
        <>
          <span className={styles.saveButton__spinner} />
          Saving...
        </>
      ) : (
        'Save Quiz'
      )}
    </motion.button>
  );
}
